<sm-data-table-builder [dataTableObject]="datatableObject" [datas]="data" [loading]="loading"></sm-data-table-builder>
<sm-dialog #dialog [dialog]="uploadDialogObject"></sm-dialog>